import React, {useEffect, useState} from 'react';
import Grid from "@material-ui/core/Grid";
import {ContentHeader} from "../../components/ui-base/content-header";
import {PublisherBookShort} from "../../components/publisher/books/publisher-book-short";
import {PublisherService} from "../../services/publisher.service";
import {toggleLoader} from "../../store/global/global-slice";
import {useDispatch} from "react-redux";
import {PublisherSimilarBookListModel} from "../../models/publisher/publisher-similar-book-list.model";
import {ApplicationStatusEnum} from "../../models/application-status.enum";
import {useTranslation} from "react-i18next";

const PublisherToPublishListPage = () => {
    const [manuscripts, setManuscripts] = useState<any>([]);
    const dispatch = useDispatch();
    const { t } = useTranslation(['publisher', 'common']);

    useEffect(() => {
        dispatch(toggleLoader(true));

        const loadManuscripts = async () => {
            const manuscripts = await PublisherService.getApplications();

            if (manuscripts) {
                setManuscripts(manuscripts.results.filter((manuscript) => manuscript.status === ApplicationStatusEnum.AutWant || manuscript.status === ApplicationStatusEnum.PubWant));
            }

            dispatch(toggleLoader(false));
        }

        loadManuscripts();
    }, [dispatch]);

    return (
        <Grid container direction={"column"} spacing={2}>
            <ContentHeader title={t('toPublish.title')}/>

            <Grid item container direction={"row"} spacing={2}>
                {manuscripts.map((application: PublisherSimilarBookListModel, index) => (
                    <PublisherBookShort key={index} manuscript={application}/>
                ))}
            </Grid>
        </Grid>
    )
}

export default PublisherToPublishListPage;
